import { logFloodgateActivity } from '../actions/publicActions';
import {
    default as loadAndInitializeFloodgateEngine,
    InitParam,
} from '../utils/loadAndInitializeFloodgateEngine';
import { orchestrator } from 'satcheljs';
import { isFeatureEnabled } from 'owa-feature-flags';
import { getUserConfiguration } from 'owa-session-store';

export default orchestrator(logFloodgateActivity, async actionMessage => {
    const initParam: InitParam = {
        SearchTraceId: actionMessage.searchTraceId,
        Flights: getFloodgateFlights(), // Add interested flights. Floodgate Survey doesn't allow null here.
    };

    // Make sure the engine is loaded. If loaded, this is a no-op
    await loadAndInitializeFloodgateEngine(initParam);

    // Then log the activity
    if (window.OfficeBrowserFeedback && window.OfficeBrowserFeedback.floodgate) {
        const floodGateEngine = window.OfficeBrowserFeedback.floodgate.getEngine();
        if (floodGateEngine) {
            floodGateEngine.getActivityListener().logActivity(actionMessage.activityType);
        }
    }
});

function getFloodgateFlights(): string {
    let floodgateFlights: string;

    floodgateFlights += isFeatureEnabled('doc-SxS-jsApi-ODB-Core') ? 'JsApi;' : 'LegacyWac;';

    floodgateFlights += 'InboxPlusSession';

    floodgateFlights += isFocusedInboxEnabled() ? 'FocusedOther' : 'Inbox';
    floodgateFlights += isFeatureEnabled('tri-inboxPlusDefaultTabs') ? 'Treatment;' : 'Control;';

    return floodgateFlights;
}

// Gets if Focused Inbox feature is enabled for the user
function isFocusedInboxEnabled(): boolean {
    return (
        getUserConfiguration().UserOptions.IsFocusedInboxFeatureSupported &&
        getUserConfiguration().UserOptions.IsFocusedInboxEnabled
    );
}
